import * as React from 'react';

import { singleton } from 'logic/singleton';
import type { SelectableLogViewMessage } from 'logview/types';
import type { DataLakeActionValues } from 'data-lake/Types';

type RetrievalContextValue = {
  bulkRetrievePayload: (
    messages: SelectableLogViewMessage[],
    dataLakeId: string,
    payload: unknown,
  ) => {
    messages: SelectableLogViewMessage[];
    data_lake_id: string;
    type: string;
    timeout: undefined | number;
  };
  onRetrieveMessages?: (values: DataLakeActionValues, from: string, to: string) => Promise<unknown>;
};
const RetrievalContext = React.createContext<RetrievalContextValue>(undefined);

export default singleton('contexts.RetrievalContext', () => RetrievalContext);
